// Servicio para manejar operaciones de vote boosters con la base de datos
import { environment } from '../config/environment';
import { getApiHeaders, getApiHeadersForGet } from '../utils/apiUtils';

class VoteBoosterService {
  constructor() {
    this.baseUrl = environment.apiBaseUrl;
  }

  // Definir tiers de vote boosters según el documento
  static BOOSTER_TIERS = {
    '$0': { votes: 1, price: 0 },
    '$1': { votes: 1, price: 1 },
    '$5': { votes: 10, price: 5 },
    '$10': { votes: 25, price: 10 },
    '$20': { votes: 60, price: 20 },
    '$50': { votes: 200, price: 50 },
    '$100': { votes: 450, price: 100 },
    '$250': { votes: 1200, price: 250 },
    '$500': { votes: 3000, price: 500 }
  };

  // Obtener todos los vote boosters
  async getAllVoteBoosters() {
    try {
      const response = await fetch(`${this.baseUrl}/vote-boosters`, {
        headers: getApiHeadersForGet()
      });
      
      if (!response.ok) {
        throw new Error(`Error ${response.status}: ${response.statusText}`);
      }

      const boosters = await response.json();
      return boosters;
    } catch (error) {
      console.error('Error fetching vote boosters:', error);
      throw error;
    }
  }

  // Obtener vote boosters por concurso
  async getVoteBoostersByContest(contestId) {
    try {
      const response = await fetch(`${this.baseUrl}/vote-boosters/contest/${contestId}`, {
        headers: getApiHeadersForGet()
      });
      
      if (!response.ok) {
        throw new Error(`Error ${response.status}: ${response.statusText}`);
      }

      const boosters = await response.json();
      return boosters;
    } catch (error) {
      console.error('Error fetching vote boosters by contest:', error);
      throw error;
    }
  }

  // Obtener vote boosters por participante
  async getVoteBoostersByParticipant(participantId) {
    try {
      const response = await fetch(`${this.baseUrl}/vote-boosters/participant/${participantId}`, {
        headers: getApiHeadersForGet()
      });
      
      if (!response.ok) {
        throw new Error(`Error ${response.status}: ${response.statusText}`);
      }

      const boosters = await response.json();
      return boosters;
    } catch (error) {
      console.error('Error fetching vote boosters by participant:', error);
      throw error;
    }
  }

  // Obtener revenue total por concurso
  async getTotalRevenueByContest(contestId) {
    try {
      const response = await fetch(`${this.baseUrl}/vote-boosters/revenue/contest/${contestId}`, {
        headers: getApiHeadersForGet()
      });
      
      if (!response.ok) {
        throw new Error(`Error ${response.status}: ${response.statusText}`);
      }

      const revenue = await response.json();
      return revenue;
    } catch (error) {
      console.error('Error fetching vote booster revenue:', error);
      throw error;
    }
  }

  // Comprar vote booster
  async purchaseVoteBooster(boosterData) {
    try {
      const response = await fetch(`${this.baseUrl}/vote-boosters`, {
        method: 'POST',
        headers: getApiHeaders(),
        body: JSON.stringify(boosterData)
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || `Error ${response.status}: ${response.statusText}`);
      }

      const result = await response.json();
      return result;
    } catch (error) {
      console.error('Error purchasing vote booster:', error);
      throw error;
    }
  }

  // Actualizar estado de pago
  async updatePaymentStatus(id, paymentStatus, paymentReference) {
    try {
      const response = await fetch(`${this.baseUrl}/vote-boosters/${id}/payment`, {
        method: 'PUT',
        headers: getApiHeaders(),
        body: JSON.stringify({
          payment_status: paymentStatus,
          payment_reference: paymentReference
        })
      });

      if (!response.ok) {
        throw new Error(`Error ${response.status}: ${response.statusText}`);
      }

      const result = await response.json();
      return result;
    } catch (error) {
      console.error('Error updating payment status:', error);
      throw error;
    }
  }

  // Obtener tier info
  getTierInfo(tier) {
    return VoteBoosterService.BOOSTER_TIERS[tier] || null;
  }

  // Obtener todos los tiers disponibles
  getAllTiers() {
    return Object.keys(VoteBoosterService.BOOSTER_TIERS).map(tier => ({
      tier,
      ...VoteBoosterService.BOOSTER_TIERS[tier]
    }));
  }
}

export default new VoteBoosterService();

